var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"small":"","color":_vm.color,"href":_vm.link,"target":"_blank"},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}},[_c('v-icon',[_vm._v(_vm._s(_vm.mdi))]),_vm._v(_vm._s(_vm.text))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }